<template>
  <profile-edit-section-card
    v-if="localState"
    title="Specialty Skills"
    breadcrumb-label="Profile"
    :has-unsaved-changes="hasUnsavedChanges"
    @breadcrumb-click="cancelEdit"
    @save="handleSave"
    @cancel="cancelEdit"
  >
    <fieldset>
      <legend class="form__label pb-8">Languages spoken</legend>
      <MultiselectComboBox
        id="languagesSpoken"
        :preselected-options="localState?.languagesSpoken || []"
        :options="Object.entries(languageMap).map(([value, { text }]) => ({ value, display: text }))"
        label-name="Languages spoken"
        @selected-options="handleLanguageUpdate"
      />
    </fieldset>
  </profile-edit-section-card>
</template>

<script lang="ts">
import ProfileEditSectionCard from '../../components/ProfileEditSectionCard.vue';
import MultiselectComboBox from '@/components/multiselect_combo_box/MultiselectComboBox.vue';

import profileEditMixin from '../../mixins/profileEditMixin';
import { languageMap } from '@/apps/provider/profile/__types__/SkillsTypes';

export default {
  name: 'SpecialtySkillsForm',
  components: {
    ProfileEditSectionCard,
    MultiselectComboBox,
  },
  mixins: [profileEditMixin],
  data() {
    return {
      localState: null,
      originalState: null,
      languageMap: languageMap,
    };
  },
  computed: {
    hasUnsavedChanges(): boolean {
      if (!this.localState || !this.originalState) return false;
      return JSON.stringify(this.localState) !== JSON.stringify(this.originalState);
    },
  },
  watch: {
    $route() {
      this.initializeFormState();
    },
    formState: {
      handler(newState) {
        if (newState) {
          this.initializeFormState();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeFormState();
  },
  methods: {
    initializeFormState() {
      const state = this.formState as Record<string, any> | null;
      if (!state) return;
      this.localState = {
        languagesSpoken: state.languagesSpoken || null,
      };
      this.originalState = JSON.parse(JSON.stringify(this.localState));
    },
    handleLanguageUpdate(languages) {
      const arr = languages.map((language) => language.value);
      this.localState.languagesSpoken = arr;
    },
    async handleSave() {
      if (!this.localState) return;

      if (this.hasUnsavedChanges) {
        await this.saveSection({
          languagesSpoken: this.localState.languagesSpoken,
        });
      }
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
</style>
